<template>
  <div class="container">    
      <h2>Puestos de Visita</h2>
        <div class="row" v-if="traerdatapuestos.length"> <!--cards-->            
          <b-card-group deck v-for="(puesto,index) in traerdatapuestos " :key="index" class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2">
            <b-card  :title="puesto.text" class="disponible my-1" :class="{Nodisponible: !puesto.disponible}">
              <b-card-text>
              </b-card-text>          
            </b-card>
          </b-card-group>      
    </div> <!--/cards-->
    <div v-else>
        <form>
            <div class="form-group">
                <label class='etiquetaLabel' for="numerodepuestos">Puestos Visita</label><br/>
                <input id='numerodepuestos' type="number" class="etiqueta" v-model.number="numerodepuestos" min='1' max="100"  size="2" maxlength="2">           
            </div>
            <button class="bnt btn-block btn-primary p-2 etiquetaLabel" @click.prevent="generarPuestos" >Generar </button>
        </form>
    </div>




  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name:'Puestos',
    data(){
        return{
           numerodepuestos:'' 
        }
    },
    computed:{
        traerdatapuestos(){
            return this.$store.getters.enviardatapuestos;
        }
    },
    methods:{
        generarPuestos(){
            if(!this.numerodepuestos){
                Swal.fire("Escriba la cantidad de puestos de visita a generar");
            }else{
                for (let i = 1; i <= this.numerodepuestos; i++) {
                    let auxiliar = {
                        text: i.toString(),
                        value:i,
                        disponible:true
                    }
                    this.$store.dispatch('generapuesto', auxiliar)                    
                }
            }
        }
    }
}
</script>

<style scoped>

.disponible{
    background-color: white;
    color: black;
}
.Nodisponible{
    background-color: red;
    color: white;
}


</style>